import { MultilineText } from "@app/components/core/MultilineText/MultilineText"

import { Loader } from "@app/components/core/Loader/Loader"
import { Separator } from "@app/components/core/Separator/Separator"
import { useCustomNavigation } from "@app/components/navigation/NavigationHandler"
import OrderLine from "@app/components/order/OrderLine/OrderLine"
import OrderLines from "@app/components/order/OrderLines/OrderLines"
import { PriceSummaryRow } from "@app/components/order/PriceSummary/PriceSummary"
import Page from "@app/components/pageTypes/Page/Page"
import { useGetStrings } from "@app/store/service/cmsService"
import { useGetAmazonOrderStatus, useGetOrder, useVerfiyAmazonPayment } from "@app/store/service/connectorService"
import { IframeMessages, ORDER_LINE_TYPES } from "@app/utils/constants"
import tracking from "@app/utils/tracking"
import { useEffect, useRef, useState } from "react"
import { useSearchParams } from "react-router"

export const OrderSucceed = () => {
	//IF we have an internal page change params2 are filled
	//otherwhise the params
	const [params2] = useSearchParams()
	const params = new URLSearchParams(window.location.search)

	const amazonCheckoutSessionId = params.get("amazonCheckoutSessionId")
	const [webToken, setWebToken] = useState(params.get("webToken") || params2.get("webToken"))
	const [show, setShow] = useState(amazonCheckoutSessionId ? false : true)
	const { replace } = useCustomNavigation()

	const {
		data: {
			orderOverviewPriceOverviewTitle,
			orderOverviewTransportCosts,
			orderOverviewPriceSum,
			orderSucceedTitle,
			orderSucceedTextBlock,
			orderSucceedYourOrder,
			orderOverviewVAT,
			orderNumber: orderNumberTitle,
		},
	} = useGetStrings(undefined, { defaultData: {} })
	const { data: amazonStatus } = useGetAmazonOrderStatus({ checkoutSessionId: amazonCheckoutSessionId }, { skip: !amazonCheckoutSessionId })
	const { data: order, refetch: refetchOrder } = useGetOrder({ webToken }, { skip: !webToken })
	const [verifyAmazonOrder] = useVerfiyAmazonPayment()
	const callCounter = useRef(0)
	const callTimer = useRef(undefined)

	useEffect(() => {
		if (window.self !== window.top) {
			window.parent.postMessage(IframeMessages.deleteShoppingCart, "*")
		}
	}, [])

	useEffect(() => {
		if (amazonStatus && !webToken) {
			verifyAmazonOrder({ checkoutSessionId: amazonCheckoutSessionId })
				.unwrap()
				.then(() => {
					setWebToken(amazonStatus.webToken)
				})
				.catch(() => {
					replace("/order-failed")
				})
				.finally(() => {
					setShow(true)
				})
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [amazonStatus])

	useEffect(() => {
		if (order && !order.processed) {
			if (callCounter.current > 5) {
				return
			}
			callTimer.current = setTimeout(() => {
				callCounter.current += 1
				refetchOrder()
			}, 1000)

			return
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [order])

	useEffect(() => {
		if (order && callCounter.current === 0) {
			tracking.addTradeDeskPixel(order)
			tracking.purchase(order)
		}
	}, [order])

	if (!show) {
		return <Loader show />
	}

	return (
		<Page className="container-md pt-12 px-4">
			<h1 className="f2 mb-3 text-center">{orderSucceedTitle}</h1>
			<div className="color-bg-light-blue-100 p-3">
				<span className="color-fg-dark-blue">
					<MultilineText>{orderSucceedTextBlock}</MultilineText>
				</span>
			</div>

			{order && !order.processed && callCounter.current < 5 && <Loader show />}

			{order && (order.processed || callCounter.current > 5) && (
				<>
					<div className="color-fg-secondary f4 mt-5">{orderSucceedYourOrder}</div>
					<Separator />
					<div className="color-fg-primary mb-6">
						<div className="mb-3 f5">
							<span>
								{orderNumberTitle}: {order.orderCode}
							</span>
						</div>

						<OrderLines>
							{order.orderLines.map((line, i) => {
								return <OrderLine isEditable={false} key={i} ignoreIds={[ORDER_LINE_TYPES.Payment]} orderLine={line} />
							})}
						</OrderLines>

						<div className="color-fg-secondary f4 mt-5">{orderOverviewPriceOverviewTitle}</div>
						<Separator />

						<OrderLines>
							{order.transporterAmount && order.transporterAmount > 0 ? (
								<PriceSummaryRow text={orderOverviewTransportCosts} price={order.transporterAmount} />
							) : null}
							<PriceSummaryRow text={orderOverviewPriceSum} price={order.payAmount} bold />
							{callCounter.current < 5 && <PriceSummaryRow text={orderOverviewVAT} price={order.totalTaxAmount || 0} />}
						</OrderLines>
						<div className="mb-6" />
					</div>
				</>
			)}
		</Page>
	)
}
